export default "__VITE_ASSET__8bc007da__"